import React from "react";
import { Image } from "react-bootstrap";
import { PATHS } from "../../constant";
// import About_PMG_banner from "../../assets/About_PMG_banner.svg";
import About_Us_banner from "../../assets/New_banner.svg";
import About_Us_Breadcrumb from "../../assets/About_Us_Breadcrumb.svg";
import Arrow_Icon from "../../assets/Arrow_Icon.svg";
import brochureFile from "../../assets/pdf/Project Monitoring Group Brochure.pdf";
import Mission_Icon from "../../assets/Mission_Icon.svg";
import Vision_Icon from "../../assets/Vision_Icon.svg";
import Values_Icon from "../../assets/Values_Icon.svg";
import Green_Border from "../../assets/green-border.svg";
import Contact_Arrow from "../../assets/Contact_Arrow.svg"; // white arrow for the button
const SECTORS = [
  "Road & Highways, Railways, Metro, Civil Aviation, Ports and Shipping, Inland Waterways",
  "Power Generation & Transmission, Coal, Oil & Gas",
  "Chemicals, Pharmaceuticals, Fertilizers, Cement, Steel, Mining",
  "Urban Development, Healthcare, Education, Logistics Park",
  "Telecommunication and IT Services"
];

const UNION_MINISTRIES = [
  "Environment, Forest and Wildlife Clearances",
  "Industrial licences and other statutory approvals",
  "Railway connectivity, private railway sidings and related permissions",
  "Permissions for crossings of National Highways, railway lines and other Central infrastructure",
  "Grant of Right of Way (RoW) or Right of Use (RoU) permissions",
  "Shifting of utilities and permissions for laying pipelines, transmission lines and other infrastructure",
  "Approvals relating to coal linkages, mining and other energy or resource-related matters, wherever applicable"
];
const STATE_GOVERNMENTS = [
  "Land acquisition, issuance of notifications, disbursement of compensation and handing over of land possession",
  "Transfer or allotment of Government land and related land-record issues",
  "Removal of encroachments and resolution of land-related bottlenecks",
  "Approval and implementation of Relief and Rehabilitation (R&R) plans",
  "Applicable permissions under the Forest Rights Act and State Forest Department approvals such as Tree felling permission",
  "Grant of Consent to Establish (CTE) and Consent to Operate (CTO) by State Pollution Control Boards",
  "Grant of Right of Way (RoW) or Right of Use (RoU) permissions and shifting of utilities",
  "Provision of power and water supply connections",
  "Permissions for road crossings, access roads and connectivity to project sites",
  "Support in resolving law-and-order issues affecting project implementation",
  "Approvals from State departments, district administrations, development authorities and local bodies",
  "Any other State Government clearance, approval or coordination issue affecting project implementation"
];
const REQUISITE_CONDITIONS = [
  "Central Government-funded Projects: All projects involving an investment of ₹500 crore or above must mandatorily be uploaded on the PMG Portal for monitoring. Projects below this threshold may also be considered on a case-to-case basis, depending on their criticality or national importance.",
  "Private-Sector Projects: Projects involving an investment of ₹500 crore or above and having pending issues with Central or State Government authorities that require PMG's intervention may be uploaded on the portal."
];

const ISSUE_STAGES = [
  "Registration: The Project Proponent (PP) creates login credentials on the PMG Portal.",
  "Project Submission: The PP uploads project details and milestones along with pending issues.",
  "Verification: The Sponsoring Ministry verifies the project and the issues raised.",
  "Issue Facilitation: PMG coordinates with the concerned Ministries and State Governments and conducts review meetings.",
  "Status Updates: The concerned authorities update the issue status; PMG Team uploads the review meeting minutes on the portal.",
  "Closure: The issue is closed after resolution, with confirmation from the PP and the concerned Government authorities."
];
const PURPOSE_CARDS = [
  {
    title: "Our Mission",
    icon: Mission_Icon,
    text:
      "Facilitate timely resolution of issues and bottlenecks affecting key infrastructure projects through structured monitoring, stakeholder coordination and a technology-enabled platform."
  },
  {
    title: "Our Vision",
    icon: Vision_Icon,
    text:
      "Enable efficient and timely completion of projects by strengthening coordination among Central Ministries, State Governments and User Agencies, and promoting data-driven monitoring and decision-making."
  },
  {
    title: "Our Values",
    icon: Values_Icon,
    text:
      "Foster collaboration, uphold accountability and transparency, and embrace technological innovation to advance effective governance"
  }
];
const NumberedList = ({ items }) => (
  <ol className="about-us-numbered-list">
    {items.map(item => (
      <li key={item}>{item}</li>
    ))}
  </ol>
);
const ArrowList = ({ items }) => (
  <ul className="about-us-list">
    {items.map(item => (
      <li key={item}>
        <img src={Arrow_Icon} alt="" className="about-us-list-icon" />
        {item}
      </li>
    ))}
  </ul>
);

const AboutUs = () => {
  return (
    <div className="about-us-container">
      {/* <Image src={About_Us_Breadcrumb} />
      <Image src={About_PMG_banner} /> */}
      {/* Breadcrumb */}
      <nav aria-label="breadcrumb" className="page-breadcrumb">
        <ol>
          <li>
            <li className="crumb-home">Home</li>
          </li>
          <li className="active" aria-current="page">
            About Us
          </li>
        </ol>
      </nav>

      {/* Banner */}
      <div className="page-banner">
        <Image src={About_Us_banner} alt="" className="page-banner-img" />
        <h1 className="page-banner-title">About Us</h1>
      </div>
      <div className="about-us-content">
        <div className="about-us-header">
          <h1 className="about-us-title">Project Monitoring Group</h1>
          <a
            href={brochureFile}
            className="about-us-brochure-btn"
            target="_blank"
            rel="noopener noreferrer"
          >
            Download PMG brochure
          </a>
        </div>

        {/* <p className="about-us-lead">
          PMG is an institutional mechanism for milestone-based monitoring of
          projects and expediting the resolution of issues and regulatory
          bottlenecks in projects involving investments above ₹500 crore in
          India.
        </p> */}

        <p className="about-us-text">
          The Project Monitoring Group (PMG), part of the newly established{" "}
          <strong>Integrated Transport &amp; Logistics Authority (ITLA)</strong>{" "}
          under the Cabinet Secretariat, Government of India, is an
          institutional mechanism for{" "}
          <strong>
            milestone-based monitoring of projects and expediting the resolution
            of issues and regulatory bottlenecks
          </strong>{" "}
          in projects involving investments above ₹500 crore in India.
        </p>

        <p className="about-us-text">
          Established as a special cell in the Cabinet Secretariat, Government
          of India, in 2013, PMG was brought under the administrative control of
          the Prime Minister's Office (PMO) in 2015. In 2019, it was merged with
          Invest India under the Department for Promotion of Industry and
          Internal Trade (DPIIT), Ministry of Commerce and Industry, to provide
          investors with a one-stop facilitation mechanism across the investment
          lifecycle, including project monitoring and issue resolution. In
          August 2021, the PMO appointed PMG as the Secretariat to the
          Monitoring Group.{" "}
          <strong>
            Since January 2026, PMG has been reporting to the Secretary
            (Coordination), Cabinet Secretariat.
          </strong>
        </p>

        <p className="about-us-text">
          Through milestone-based monitoring, PMG facilitates early
          identification of implementation challenges and timely corrective
          action to prevent delays and cost overruns. It supports public,
          private and Public–Private Partnership (PPP) projects by{" "}
          <strong>
            facilitating approvals, addressing sectoral policy issues and
            resolving bottlenecks
          </strong>{" "}
          through coordination among stakeholders, thereby supporting timely
          project commissioning.
        </p>

        <h2 className="about-us-subtitle">Sectors Covered</h2>
        <p className="about-us-text">
          Projects monitored by PMG are largely infrastructural in nature,
          however, projects from other sectors may also be taken up, provided
          they meet the prescribed investment threshold and fall within PMG's
          mandate. The sectors covered include:
        </p>
        <ArrowList items={SECTORS} />

        <h2 className="about-us-subtitle">Issues Facilitated by PMG</h2>
        <p className="about-us-text">
          PMG facilitates the resolution of issues arising at both the Union
          Government and State Government levels. These include, but are not
          limited to, the following:
        </p>
        <h3 className="about-us-group-title">Union Ministries</h3>
        <ArrowList items={UNION_MINISTRIES} />
        <h3 className="about-us-group-title">State Governments</h3>
        <ArrowList items={STATE_GOVERNMENTS} />
        <h2 className="about-us-title about-us-section-title">PMG Mechanism</h2>
        <img src={Green_Border} alt="" />

        <h3 className="about-us-group-title">
          Requisite Conditions for Uploading a Project on the PMG Portal
        </h3>
        <ArrowList items={REQUISITE_CONDITIONS} />

        <h3 className="about-us-group-title">Stages of Issue Resolution</h3>
        <NumberedList items={ISSUE_STAGES} />
      </div>
      <section className="about-us-purpose">
        <div className="about-us-purpose-inner">
          <h2 className="about-us-title about-us-section-title">
            The purpose that guides us
          </h2>
          <img src={Green_Border} alt="" />
          <div className="purpose-cards">
            {PURPOSE_CARDS.map(card => (
              <div className="purpose-card" key={card.title}>
                <div className="purpose-card-header">
                  <img src={card.icon} alt="" className="purpose-card-icon" />
                  <h3 className="purpose-card-title">{card.title}</h3>
                </div>
                <p className="purpose-card-text">{card.text}</p>
              </div>
            ))}
          </div>

          <div className="about-us-connect">
            <div className="about-us-connect-text">
              <span className="about-us-connect-label">CONNECT WITH PMG</span>
              <h2 className="about-us-connect-title">
                Let’s move the conversation forward.
              </h2>
              <p className="about-us-connect-desc">
                For information and assistance regarding PMG’s mandate and
                functioning, please contact the PMG team
              </p>
            </div>
            <a href={PATHS.CONTACT_US_PAGE} className="about-us-contact-btn">
              Contact Us
              <img src={Contact_Arrow} alt="" />
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutUs;
